//#region import
import React, { useContext, useEffect, useState } from 'react';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { ProjectContext } from '../ProjectRequestFrom';
import { BtnSend } from 'components/Button/ButtonAll';
import { Convert, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { ApiProject } from 'enum/api';
import ErrorIcon from '@mui/icons-material/Error';
import { parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { TextAreaItem } from 'components/Input/TextArea';
import { List as LINQ } from "linqts";
import InputNumberItem from 'components/Input/InputNumber';
import _ from "lodash";
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ProjectScoringCriteria = () => { //เกณฑ์การให้คะแนน
    const {
        nProjectID,
        isFastTrack,
        isPermission,
        nStatusID,
        sMode,
        sTabID,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();

    //#region useState
    const [ObjExampleFile, setObjExampleFile] = useState(null);
    const [ObjDataProject, setObjDataProject] = useState(null);

    const [nCriteriaYearID, setnCriteriaYearID] = useState(0);
    const [nCommitteeID, setnCommitteeID] = useState(0);
    const [nTotalScore, setnTotalScore] = useState(null); //คะแนนที่ได้ All
    const [nTotalWeightScore, setnTotalWeightScore] = useState(null); //คะแนนที่ได้ (คิดค่าน้ำหนัก) All

    const [lstScoringCriteria, setlstScoringCriteria] = useState([]);  //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา
    //// const [lstScoringCriteriaForm, setlstScoringCriteriaForm] = useState([]);  //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา (ข้อมูลเดิมของ DB)
    //#endregion

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
    }, [nProjectID]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectScore, { nProjectID: nProjectID }, (result) => {
            setObjExampleFile(result.ObjExampleFile);
            setObjDataProject(result.ObjDataProject);

            setnCriteriaYearID(result.nCriteriaYearID); //TmProjectCriteriaYear
            setnCommitteeID(result.nCommitteeID); //TbCommitteeUser
            setnTotalScore(result.nTotalScore); //คะแนนที่ได้ All
            setnTotalWeightScore(result.nTotalWeightScore); //คะแนนที่ได้ (คิดค่าน้ำหนัก) All

            setlstScoringCriteria(result.lstScoringCriteria); //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา
            //// setlstScoringCriteriaForm(_.cloneDeep(result.lstScoringCriteria)); //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา (ข้อมูลเดิมของ DB)
        });
    }

    const onExample = () => {
        // โหลดไฟล์เปิดมาอีกแท็บ
        // sExampleFile โหลดไฟล์เปิดมาอีกแท็บ // ตัวอย่างการกรอกข้อมูล กท.1 // ObjExampleFile

        if (ObjExampleFile?.sPathFile && ObjExampleFile?.sFileName) {
            // downloadFile(ObjExampleFile?.sPathFile, ObjExampleFile?.sFileName);            
            window.open(ObjExampleFile?.sPathFile, "_blank", 'noopener,noreferrer');
        }
    }

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const SetValueSum = (arr) => {
        let v = (arr || []).filter(f => f !== undefined && f !== null);
        if (v.length > 0) {
            let val = new LINQ<any>(v).Sum(s => s);
            return parseFloatCheckValue(val);
        } else {
            return "";
        }
    }

    //#region Old
    // const CallTableScoringCriteria = useCallback(() => {
    //     let arrSum_nFullScore = [];
    //     let arrSum_nFullWeight = [];
    //     let arrSum_nScore = [];
    //     let arrSum_nWeightScore = [];
    //     return (
    //         <TableContainer id='table-ScoringCriteria' component={Paper}>
    //             <Table sx={{ minWidth: 1000 }}>
    //                 <TableHead>
    //                     <TableRow>
    //                         <TableCell component="th" padding='none' style={{ minWidth: '220px', width: '220px' }} >
    //                             <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'} alignItems={'center'}>
    //                                 <Grid item>
    //                                     {"เกณฑ์การให้คะแนน "}
    //                                 </Grid>
    //                                 <Grid item>
    //                                     {/* <BtnExample id={"BtnExample_ScoringCriteria"} txt={"หลักเกณฑ์"} IsCircleWithOutText={true} onClick={onExample} /> */}
    //                                     <Tooltip placement={'right-end'} title={"หลักเกณฑ์"}>
    //                                         <ErrorIcon id={"BtnExample_ScoringCriteria"} color='primary' onClick={onExample} />
    //                                     </Tooltip>
    //                                 </Grid>
    //                             </Grid>
    //                         </TableCell>
    //                         <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >คะแนนเต็ม</TableCell>
    //                         <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >
    //                             <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'} alignItems={'center'}>
    //                                 <Grid item>
    //                                     {"คะแนนที่ได้"}
    //                                 </Grid>
    //                                 <Grid item>
    //                                     <Typography variant='body1' color={'red'}>*</Typography>
    //                                 </Grid>
    //                             </Grid>
    //                         </TableCell>
    //                         <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนเต็ม <br/>(คิดค่าน้ำหนัก)")}</TableCell>
    //                         <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนที่ได้ <br/>(คิดค่าน้ำหนัก)")}</TableCell>
    //                         <TableCell component="th" padding='none' style={{ minWidth: '140px', width: '140px' }} >หมายเหตุ</TableCell>
    //                     </TableRow>
    //                 </TableHead>  
    //                     {(lstScoringCriteria || []).length === 0 ?
    //                         <StyledTableRow key={`sID_ScoringCriteria_`}>
    //                             <TableCell align="center" colSpan={6} style={{ padding: '3%' }}>ไม่พบข้อมูล</TableCell>
    //                         </StyledTableRow>
    //                         :
    //                         <TableBody>
    //                             {(lstScoringCriteria || []).map((iCriteria) => {
    //                                 if (iCriteria.nFullScore !== null) arrSum_nFullScore.push(iCriteria.nFullScore);
    //                                 if (iCriteria.nFullWeight !== null) arrSum_nFullWeight.push(iCriteria.nFullWeight);

    //                                 if (iCriteria.nScore !== null) arrSum_nScore.push(iCriteria.nScore);
    //                                 if (iCriteria.nWeightScore !== null) arrSum_nWeightScore.push(iCriteria.nWeightScore);

    //                                 return (
    //                                     <TableRow key={`sID_ScoringCriteria_${iCriteria.nCriteriaID}`}>
    //                                         <TableCell align="left">
    //                                             <Grid item xs={12} md={12}>
    //                                                 <Typography variant='body2'>{ParseHtml(iCriteria.sCriteria + "")}</Typography>
    //                                             </Grid>  
    //                                         </TableCell>
    //                                         <TableCell align="center">
    //                                             <Grid item xs={12} md={12}>
    //                                                 <Typography variant='body2'>{formatNumber(iCriteria.nFullScore, 0)}</Typography>
    //                                             </Grid>  
    //                                         </TableCell>
    //                                         <TableCell align="center">
    //                                             {/* nScore */}
    //                                             <InputNumberItem
    //                                                 id={"nScore_" + iCriteria.nCriteriaID}
    //                                                 name={"nScore_" + iCriteria.nCriteriaID}
    //                                                 label={""} //คะแนนที่ได้
    //                                                 IsComma={true}
    //                                                 IsAllowScientific={false}
    //                                                 type={"Number"}
    //                                                 ShowDigits={0}
    //                                                 maxDigits={0}
    //                                                 maxInteger={3} 
    //                                                 min={0}     
    //                                                 max={iCriteria.nFullScore}
    //                                                 required={true}
    //                                                 disabled={sMode !== "Update"}
    //                                                 defaultValue={iCriteria.nScore} 
    //                                                 IsShowMessageError={false}
    //                                                 // onBlur={(e) => {
    //                                                 onChange={(e) => {
    //                                                     // iCriteria.nScore = Convert.StringToIntOrNull(e);
    //                                                     // iCriteria.nWeightScore = iCriteria.nScore !== null ? iCriteria.nFullScore !== 0 ? ((iCriteria.nScore * iCriteria.nFullWeight) / iCriteria.nFullScore) : 0 : null;
    //                                                     // if (iCriteria.nScore !== null)
    //                                                     // {
    //                                                     //     if (iCriteria.nScore === 0 || iCriteria.nFullScore === 0) {
    //                                                     //         iCriteria.nWeightScore = Convert.StringToFloat("0.00");
    //                                                     //     }
    //                                                     //     else {
    //                                                     //         iCriteria.nWeightScore = Convert.StringToFloat(((iCriteria.nScore * iCriteria.nFullWeight) / iCriteria.nFullScore) + "");    
    //                                                     //     }
    //                                                     // }
    //                                                     // else {
    //                                                     //     iCriteria.nWeightScore = null;
    //                                                     // }
    //                                                     // let nSumTotalScore = new LINQ<any>(lstScoringCriteria || []).Sum(s => s.nScore);
    //                                                     // let nSumTotalWeightScore = new LINQ<any>(lstScoringCriteria || []).Sum(s => s.nWeightScore);
    //                                                     // setnTotalScore(nSumTotalScore); //คะแนนที่ได้ All
    //                                                     // setnTotalWeightScore(nSumTotalWeightScore); //คะแนนที่ได้ (คิดค่าน้ำหนัก) All
    //                                                     // setlstScoringCriteria((value: any) => [...value]);

    //                                                     handleChangeValue(Convert.StringToIntOrNull(e), indexCriteria, iCriteria);
    //                                                 }}
    //                                             />
    //                                         </TableCell>
    //                                         <TableCell align="center">
    //                                             <Grid item xs={12} md={12}>
    //                                                 <Typography variant='body2'>{formatNumber(iCriteria.nFullWeight, 2)}</Typography>
    //                                             </Grid>  
    //                                         </TableCell>
    //                                         <TableCell align="center">
    //                                             <Grid item xs={12} md={12}>
    //                                                 <Typography variant='body2'>{formatNumber(iCriteria.nWeightScore, 2)}</Typography>
    //                                             </Grid>  
    //                                         </TableCell>
    //                                         <TableCell align="center">
    //                                             {/* sRemark */}
    //                                             <TextAreaItem
    //                                                 id={"sRemark_" + iCriteria.nCriteriaID}
    //                                                 name={"sRemark_" + iCriteria.nCriteriaID}
    //                                                 label={""} //"หมายเหตุ"
    //                                                 //placeholder={"ระบุเพิ่มเติม กรณี คะแนน 0"}
    //                                                 required={(iCriteria.nScore !== null && iCriteria.nScore !== 0) ? false : true}
    //                                                 maxLength={250}
    //                                                 row={1}
    //                                                 disabled={sMode !== "Update"}
    //                                                 IsShowMessageError={false}
    //                                                 defaultValue={iCriteria.sRemark}
    //                                                 onChange={(e) => {
    //                                                     iCriteria.sRemark = e.target.value;
    //                                                 }}
    //                                             />
    //                                         </TableCell>
    //                                     </TableRow>                                            
    //                                 )
    //                             })}
    //                             <TableRow key={`sID_ScoringCriteria_Sum`}>
    //                                 <TableCell className='bg-color' align="center">รวม</TableCell>
    //                                 <TableCell className='bg-color' align="center">{formatNumber(SetValueSum(arrSum_nFullScore), 0)}</TableCell>
    //                                 <TableCell className='bg-color' align="center">{formatNumber(SetValueSum(arrSum_nScore), 0)}</TableCell>
    //                                 <TableCell className='bg-color' align="center">{formatNumber(SetValueSum(arrSum_nFullWeight), 2)}</TableCell>
    //                                 <TableCell className='bg-color' align="center">{formatNumber(SetValueSum(arrSum_nWeightScore), 2)}</TableCell>
    //                                 <TableCell className='bg-color' align="center">{""}</TableCell>
    //                             </TableRow>
    //                         </TableBody>
    //                     }                    
    //             </Table>
    //         </TableContainer>
    //     );
    // }, [lstScoringCriteria, nTotalScore]);
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID) => {
        let param = {
            sLocation: location.pathname,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,

            nProjectID: nProjectID,
            nCriteriaYearID: nCriteriaYearID,
            nCommitteeID: nCommitteeID,
            nTotalScore: nTotalScore ?? 0, //คะแนนที่ได้ All
            nTotalWeightScore: nTotalWeightScore ?? 0, //คะแนนที่ได้ (คิดค่าน้ำหนัก) All
            lstScoringCriteria: lstScoringCriteria ?? [], //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา
        };

        DialogFn.Submit(("คุณต้องการ" + I18n.SetText("Button.RecordScore", I18NextNs.labelComponent) + "หรือไม่ ?"), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectScore, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success((I18n.SetText("Button.RecordScore", I18NextNs.labelComponent) + "สำเร็จ"), () => { navigate("/ProjectCheckRecordList") });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const handleChangeValue = (nScore, rowIndexCriteria, iCriteria) => {
        let nScoreOld = iCriteria.nScore;
        iCriteria.nScore = nScore;
        if (iCriteria.nScore !== null) {
            if (iCriteria.nScore === 0 || iCriteria.nFullScore === 0) {
                iCriteria.nWeightScore = Convert.StringToFloat("0.00");
                if (iCriteria.sRemark === null) form.setError("sRemark_" + iCriteria.nCriteriaID, { type: "error" });
            }
            else {
                iCriteria.nWeightScore = Convert.StringToFloat(((iCriteria.nScore * iCriteria.nFullWeight) / iCriteria.nFullScore) + "");
                form.clearErrors("sRemark_" + iCriteria.nCriteriaID);
            }
        }
        else {
            iCriteria.nWeightScore = null;
        }

        // let nSumTotalScore = _.sumBy(lstScoringCriteria[rowIndexCriteria].nScore, function (o: any) { return parseFloatCheckValue(o.nScore); });
        // // lstScoringCriteria[rowIndexCriteria].nTotalScore = nSumTotalScore;
        let nSumTotalScore = parseFloatCheckValue(new LINQ<any>(lstScoringCriteria).Sum(s => s.nScore));
        setnTotalScore(nSumTotalScore); //คะแนนที่ได้ All

        // let nSumTotalWeightScore = _.sumBy(lstScoringCriteria[rowIndexCriteria].nWeightScore, function (o: any) { return parseFloatCheckValue(o.nWeightScore); });
        // // lstScoringCriteria[rowIndexCriteria].nTotalScore = nSumTotalWeightScore;
        let nSumTotalWeightScore = parseFloatCheckValue(new LINQ<any>(lstScoringCriteria).Sum(s => s.nWeightScore));
        setnTotalWeightScore(nSumTotalWeightScore); //คะแนนที่ได้ (คิดค่าน้ำหนัก) All

        setlstScoringCriteria(value => [...value]);
        // setlstScoringCriteria((value: any) => [...value]);


        //Enh.2025 อนุกรรมการกลั่นกรองฯ ให้คะแนน และไปบันทึกให้ Auto ตามการกรอก
        if (nStatusID === EnumProjectStatusID.nStatusID_6) {
            handleSaveScoreAuto(iCriteria, nSumTotalScore, nSumTotalWeightScore);
        } else if (nStatusID > EnumProjectStatusID.nStatusID_6 && nStatusID < EnumProjectStatusID.nStatusID_10) {
            if (iCriteria.nScore != null && (iCriteria.nScore !== nScoreOld)) {
                handleSaveScoreAuto(iCriteria, nSumTotalScore, nSumTotalWeightScore);
            }
        }
    }

    const handleSaveScoreAuto = (iCriteria, nSumTotalScore, nSumTotalWeightScore) => {
        let param = {
            sLocation: location.pathname,
            nStatusID: nStatusID,
            nProjectID: nProjectID,
            nCriteriaYearID: nCriteriaYearID,
            nCommitteeID: nCommitteeID,
            nTotalScore: nSumTotalScore, //คะแนนที่ได้ All
            nTotalWeightScore: nSumTotalWeightScore, //คะแนนที่ได้ (คิดค่าน้ำหนัก) All
            lstScoringCriteria: lstScoringCriteria ?? [], //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา

            nCriteriaID: iCriteria.nCriteriaID,
            nScore: iCriteria.nScore, //คะแนนที่ได้
            nWeightScore: iCriteria.nWeightScore, //คะแนนที่ได้ (คิดค่าน้ำหนัก)
        };
        AxiosFn.Post(ApiProject.SaveProjectScoreAuto, param, (result) => {
            if (result.nStatusCode !== APIStatusCode.Success) DialogFn.Warning(result.sMessage);
        }, (err) => {
            if (!err.response) DialogFn.Warning(err.sMessage);
        });
    }

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <FormProvider {...form}>
                <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                    <Typography variant='h6' color={'#225192'}>ตารางการให้คะแนนโครงการขอรับเงินช่วยเหลือหรืออุดหนุนฯ</Typography>
                </Grid>
                <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                    <Typography variant='body1' color={'#225192'}>อนุกรรมการกลั่นกรองข้อเสนอโครงการขอรับเงินช่วยเหลือหรืออุดหนุนกิจการใดๆ จากกองทุนจัดการซากดึกดำบรรพ์</Typography>
                </Grid>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='body1' fontWeight="bold">ชื่ออนุกรรมการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <Typography variant='body1'>{ObjDataProject?.sSubCommitteeName}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='body1' fontWeight="bold">ตำแหน่ง</Typography>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <Typography variant='body1'>{ObjDataProject?.sPositionName}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='body1' fontWeight="bold">หน่วยงาน</Typography>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <Typography variant='body1'>{ObjDataProject?.sUnitTypeName}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='body1' fontWeight="bold">วันที่พิจารณาคะแนน</Typography>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <Typography variant='body1'>{ObjDataProject?.sScoreDate}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={2}>
                            <Typography variant='body1' fontWeight="bold">มาตรา</Typography>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <Typography variant='body1'>{ObjDataProject?.sSectionName}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} container spacing={2} alignItems={'center'}>
                    <Grid item>
                        <Typography variant='h6' color={'#225192'}>โครงการปรับปรุงแหล่งซากดึกดำบรรพ์</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant='h6' color={'#d10303'}>{ObjDataProject?.sProjectName ?? ""}</Typography>
                    </Grid>
                </Grid >
                <Grid item xs={12} md={12}>
                    <Divider style={{ color: "#212836" }} />
                </Grid>
                <Grid item xs={12} md={12}>
                    {/* <CallTableScoringCriteria /> */}
                    <TableContainer id='table-ScoringCriteria' component={Paper}>
                        <Table sx={{ minWidth: 1000 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" padding='none' style={{ minWidth: '220px', width: '220px' }} >
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'} alignItems={'center'}>
                                            <Grid item>
                                                {"เกณฑ์การให้คะแนน "}
                                            </Grid>
                                            <Grid item>
                                                {/* <BtnExample id={"BtnExample_ScoringCriteria"} txt={"หลักเกณฑ์"} IsCircleWithOutText={true} onClick={onExample} /> */}
                                                <Tooltip placement={'right-end'} title={"หลักเกณฑ์"}>
                                                    <ErrorIcon id={"BtnExample_ScoringCriteria"} color='primary' onClick={onExample} />
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >คะแนนเต็ม</TableCell>
                                    <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'} alignItems={'center'}>
                                            <Grid item>
                                                {"คะแนนที่ได้"}
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body1' color={'red'}>*</Typography>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนเต็ม <br/>(คิดค่าน้ำหนัก)")}</TableCell>
                                    <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนที่ได้ <br/>(คิดค่าน้ำหนัก)")}</TableCell>
                                    <TableCell component="th" padding='none' style={{ minWidth: '140px', width: '140px' }} >หมายเหตุ</TableCell>
                                </TableRow>
                            </TableHead>
                            {(lstScoringCriteria || []).length === 0 ?
                                <StyledTableRow key={`sID_ScoringCriteria_`}>
                                    <TableCell align="center" colSpan={6} style={{ padding: '3%' }}>ไม่พบข้อมูล</TableCell>
                                </StyledTableRow>
                                :
                                <TableBody>
                                    {(lstScoringCriteria || []).map((iCriteria, indexCriteria) => {
                                        if (iCriteria.nScore === 0 && iCriteria.sRemark === null) form.setError("sRemark_" + iCriteria.nCriteriaID, { type: "error" });

                                        return (
                                            <TableRow key={`sID_ScoringCriteria_${iCriteria.nCriteriaID}`}>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iCriteria.sCriteria + "")}</Typography>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nFullScore, 0)}</Typography>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {/* nScore */}
                                                    <InputNumberItem
                                                        id={"nScore_" + iCriteria.nCriteriaID}
                                                        name={"nScore_" + iCriteria.nCriteriaID}
                                                        label={""} //คะแนนที่ได้
                                                        IsComma={true}
                                                        IsAllowScientific={false}
                                                        type={"Number"}
                                                        ShowDigits={0}
                                                        maxDigits={0}
                                                        maxInteger={3}
                                                        min={0}
                                                        max={iCriteria.nFullScore}
                                                        required={true}
                                                        disabled={sMode !== "Update"}
                                                        defaultValue={iCriteria.nScore}
                                                        IsShowMessageError={false}
                                                        // onChange={(e) => {
                                                        onBlur={(e) => {
                                                            handleChangeValue(Convert.StringToIntOrNull(e), indexCriteria, iCriteria);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nFullWeight, 2)}</Typography>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nWeightScore, 2)}</Typography>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {/* sRemark */}
                                                    <TextAreaItem
                                                        id={"sRemark_" + iCriteria.nCriteriaID}
                                                        name={"sRemark_" + iCriteria.nCriteriaID}
                                                        label={""} //"หมายเหตุ"
                                                        //placeholder={"ระบุเพิ่มเติม กรณี คะแนน 0"}
                                                        required={(iCriteria.nScore !== null && iCriteria.nScore !== 0) ? false : true}
                                                        maxLength={250}
                                                        row={1}
                                                        disabled={sMode !== "Update"}
                                                        IsShowMessageError={false}
                                                        defaultValue={iCriteria.sRemark}
                                                        onChange={(e) => {
                                                            iCriteria.sRemark = e.target.value;
                                                            setlstScoringCriteria(value => [...value]);
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                    <TableRow key={`sID_ScoringCriteria_Sum`}>
                                        <TableCell className='bg-color' align="center">รวม</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(((lstScoringCriteria || []).filter(w => w.nFullScore != null).length > 0 ? new LINQ<any>(lstScoringCriteria || []).Where(w => w.nFullScore != null).Sum(s => s.nFullScore) : null), 0)}</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(((lstScoringCriteria || []).filter(w => w.nScore != null).length > 0 ? new LINQ<any>(lstScoringCriteria || []).Where(w => w.nScore != null).Sum(s => s.nScore) : null), 0)}</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(((lstScoringCriteria || []).filter(w => w.nFullWeight != null).length > 0 ? new LINQ<any>(lstScoringCriteria || []).Where(w => w.nFullWeight != null).Sum(s => s.nFullWeight) : null), 2)}</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(((lstScoringCriteria || []).filter(w => w.nWeightScore != null).length > 0 ? new LINQ<any>(lstScoringCriteria || []).Where(w => w.nWeightScore != null).Sum(s => s.nWeightScore) : null), 2)}</TableCell>
                                        {/* <TableCell className='bg-color' align="center">{formatNumber(SetValueSum((lstScoringCriteria || []).map(w=> w.nFullScore != null)), 0)}</TableCell>
                                            <TableCell className='bg-color' align="center">{formatNumber(SetValueSum((lstScoringCriteria || []).map(w=> w.nScore != null)), 0)}</TableCell>
                                            <TableCell className='bg-color' align="center">{formatNumber(SetValueSum((lstScoringCriteria || []).map(w=> w.nFullWeight != null)), 2)}</TableCell>
                                            <TableCell className='bg-color' align="center">{formatNumber(SetValueSum((lstScoringCriteria || []).map(w=> w.nWeightScore != null)), 2)}</TableCell> */}
                                        <TableCell className='bg-color' align="center">{""}</TableCell>
                                    </TableRow>
                                </TableBody>
                            }
                        </Table>
                    </TableContainer>

                    <Grid item style={{ display: 'none' }}>
                        <BtnSend id="BtnScore"
                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_6), (err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                                if (sTabID !== "Tab3") DialogFn.Warning("กรุณาตรวจสอบข้อมูลการลงคะแนนข้อเสนอโครงการกรอกคะแนนให้เรียบร้อย");
                            })}
                        />
                    </Grid>
                </Grid>
            </FormProvider>
        </Grid>
    )
}
export default ProjectScoringCriteria;